import { generateMockMatterVehiclePayload } from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterVehicle } from "@/lib/data/react-query/matters/matter-vehicle";
import type { Contact } from "@/lib/types";
import { useCreateMockMatterContactConnection } from "./useCreateMockMatterContactConnection";
import { useCallback } from "react";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterVehicle = () => {
  const createVehicle = useCreateMatterVehicle();
  const { createMockMatterContactConnection } =
    useCreateMockMatterContactConnection();

  const createMockMatterVehicle = useCallback(
    async (
      matterId: string,
      registeredOwner: Contact,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, async () => {
        const createdVehicle = await createVehicle.mutateAsync(
          generateMockMatterVehiclePayload(matterId, overrides),
        );

        await createMockMatterContactConnection(
          registeredOwner,
          matterId,
          "Registered Owner",
          { vehicleId: createdVehicle.data.id },
        );

        return createdVehicle;
      }),
    [createVehicle, createMockMatterContactConnection],
  );

  return {
    createMockMatterVehicle,
    mutation: createVehicle,
  };
};
